
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCautionBadge as ObiCautionBadgeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-caution-badge.js';
 
 
 

 
 export const ObiCautionBadge = createComponent({
   react: React,
   tagName: 'obi-caution-badge',
   elementClass: ObiCautionBadgeElement,
   events: {
     
   }
  });
 
 